import { closeTabAriaLabel } from 'owa-locstrings/lib/strings/closetabarialabel.locstring.json';
import { messageIsSendingTitle, messageIsSentTitle } from './ComposeTab.locstring.json';
import { messageSendingFailTitle } from 'owa-locstrings/lib/strings/messagesendingfailtitle.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import getFriendlySubject from 'owa-mail-compose-actions/lib/utils/getFriendlySubject';

import { AsyncSendState, getStore } from 'owa-mail-compose-store';
import { ComposeTabViewState, lazyCloseTab } from 'owa-tab-store';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./ComposeTab.scss');
const classNames = require('classnames');

export interface ComposeTabProps {
    viewState: ComposeTabViewState;
    className: string;
    subjectClassName: string;
}

@observer
export default class ComposeTab extends React.Component<ComposeTabProps, {}> {
    render() {
        const { viewState, className, subjectClassName } = this.props;
        const composeStore = getStore();
        const composeViewState = composeStore.viewStates.get(viewState.data);
        const subject = getFriendlySubject(composeViewState.subject);

        switch (composeViewState.asyncSendState) {
            case AsyncSendState.Timeout:
                return (
                    <div className={className} title={subject}>
                        <Spinner className={styles.leftIcon} />
                        <div className={subjectClassName}>{loc(messageIsSendingTitle)}</div>
                    </div>
                );

            case AsyncSendState.Error:
                return (
                    <div className={className} title={subject}>
                        <Icon
                            iconName={ControlIcons.Error}
                            className={classNames(styles.leftIcon, styles.error)}
                        />
                        <div className={subjectClassName}>{loc(messageSendingFailTitle)}</div>
                    </div>
                );

            case AsyncSendState.Sent:
                return (
                    <div className={className} title={subject}>
                        <Icon
                            iconName={ControlIcons.CheckMark}
                            className={classNames(styles.leftIcon, styles.checkmark)}
                        />
                        <div className={subjectClassName}>{loc(messageIsSentTitle)}</div>
                    </div>
                );

            default:
                return (
                    <div className={className} title={subject}>
                        <Icon iconName={ControlIcons.Edit} className={styles.leftIcon} />
                        <div className={subjectClassName}>{subject}</div>
                        <IconButton
                            iconProps={{ iconName: ControlIcons.Cancel }}
                            onClick={this.onClickCloseButton}
                            className={styles.rightIcon}
                            aria-label={loc(closeTabAriaLabel)}
                        />
                    </div>
                );
        }
    }

    private onClickCloseButton = (e: React.MouseEvent<unknown>) => {
        e.stopPropagation();
        lazyCloseTab.importAndExecute(this.props.viewState);
    };
}
